import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { mapShareGuestEvent } from 'tag-manager/map_share_guest'
import { InviteGuestClickable as View } from 'ui-components'
import { useAuth } from 'user-auth'
import { useMap } from '~map-preview/states/map'
import { openInviteGuestDrawer } from '~map-preview/states/ui'

export const InviteGuestClickable = () => {
  const dispatch = useDispatch()
  const { userId } = useAuth()
  const {
    workspace: { memberCollection }
  } = useMap()

  const show = useMemo(() => {
    if (!userId) return false
    return !!memberCollection?.items.find((member) => member.user.id === userId)
  }, [userId, memberCollection])

  const handleClick = () => {
    dispatch(openInviteGuestDrawer())
    mapShareGuestEvent()
  }

  if (!show) return null

  return <View onClick={handleClick} />
}
